import store from "../store"
import { Renderer } from "@unseenco/taxi"
import { Transition } from "@unseenco/taxi"
import { Emitter, Smooth } from "./"
import { Manager } from "../components"
import { WebGL } from "../core"
import { qsa, formFocus } from "../utils"
import { gsap, ScrollTrigger } from "../libraries/gsap/index"
import { qs } from "../utils"

class Page extends Renderer {
  constructor(obj) {
    super(obj)
    this.page = null
    this.components = []
    this.glComponents = []
  }

  onEnterCompleted() {
    this.page = this.wrapper.lastElementChild
    store.currentPage = this.page
    this.init()
  }

  addComponents() {
    if (this.components.length > 0) {
      this.manager = new Manager()
      this.components.forEach(obj => {
        this.manager.addComponent(obj, this)
      })
      this.manager.initializeComponents()
      this.manager.animateIn()
    }

    this.setForms()
  }

  trackImages() {
    const imgs = qsa(".lazy")
    imgs.forEach(img => {
      if (img.complete) {
        img.classList.add("loaded")
        return
      }

      img.addEventListener(
        "load",
        () => {
          img.classList.add("loaded")
        },
        { once: true }
      )
    })
  }

  tick = ({ current, diff, mouse }) => {
    const { isResizing } = store.flags
    if (isResizing) return
    this.scroll = {
      current: current,
      direction: diff > 0 ? "down" : "up",
    }
    this.mouse = { x: mouse.x, y: mouse.y }
    store.page.current = current
    this.onTick({ mouse: this.mouse, scroll: this.scroll })
  }

  onTick(obj) {
    this.manager && this.manager.update(obj)
    this.webgl?.update(obj)
  }

  resize = () => {
    this.smooth?.update()
    this.onResize()
    ScrollTrigger.refresh()
  }

  smoothResize = () => {
    this.onSmoothResize()
  }

  onResize() {
    this.manager && this.manager.resize()
    this.webgl?.resize()
  }

  onSmoothResize() {
    this.manager && this.manager.smoothResize()
    this.webgl?.smoothResize()
  }

  on() {
    Emitter.on("tick", this.tick)
    Emitter.on("resize", this.resize)
    Emitter.on("smooth:resize", this.smoothResize)
  }

  off() {
    Emitter.off("tick", this.tick)
    Emitter.off("resize", this.resize)
    Emitter.off("smooth:resize", this.smoothResize)
  }

  onLeave() {
    this.manager && this.manager.animateOut()
    this.webgl?.glManager.animateOut()
  }

  onLeaveCompleted() {
    this.off()
    this.manager && this.manager.destroy()
    this.webgl?.glManager.destroy()
    ScrollTrigger.getAll().forEach(inst => inst.kill(true))
  }

  setForms() {
    formFocus()
  }

  init() {
    ScrollTrigger.refresh()
    this.smooth = new Smooth({ scroll: store.scroll })
    this.on()
    this.trackImages()
    this.addComponents()
    this.resize()
    this.smooth.update()
  }
}

class Default extends Transition {
  constructor(obj) {
    super(obj)

    this.transition = document.querySelector(".transition")
  }

  onLeave({ from, trigger, done }) {
    const main = from.parentNode
    const header = qs("header")

    // const transition = document.querySelector('.transition');
    // const logo = transition.querySelector('.logo');

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => done(),
    })

    tl.fromTo(main, { autoAlpha: 1 }, { duration: 0.5, autoAlpha: 0 })

    tl.fromTo(header, { autoAlpha: 1 }, { duration: 0.5, autoAlpha: 0 }, "<")


    tl.play()
  }

  onEnter({ to, trigger, done }) {
    window.scrollTo({ top: 0 })
    const main = to.parentNode
    const header = qs("header")

    done()

    const tl = gsap.timeline({
      paused: true,
    })
    tl.fromTo(main, { autoAlpha: 0 }, { duration: 0.5, autoAlpha: 1 })
    tl.fromTo(header, { autoAlpha: 0 }, { duration: 0.5, autoAlpha: 1 }, "<")
    tl.play()
  }
}

export { Page, Default }
